import { IActionFn, IPageData } from '@/store/types';
import { IInstanceRawData } from '@/store/materials/types';
import { IAiKnowledgeSync, IModuleState } from './types';
import { $http, $file } from '@/axios';
import { downloadFile } from '@/utils/helper';
import store from '@/store';
import router from '@/plugins/router';

// 查询物品列表
export const queryModels: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setModels', { ...state.list, loading: true });
    // const res: IPageData = await $http.post('/model/type/item/page', payload);
    const res: IPageData = await $http.post('/v1/asset/item/pagelist', payload);
    commit('setModels', { data: res.list, pageNum: res.pageNum, pageSize: res.pageSize, total: res.total });
  } catch (e) {
    commit('setModels', { data: [], pageNum: 0, pageSize: 0, total: 0 });
  }
};

// 查询物品详情
export const queryModelDetail: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setModelDetail', { data: null, loading: true });
    // const res = await $http.get(`/model/type/item/detail/${payload}`);
    const res = await $http.get(`/v1/asset/item/${payload}/detail`);
    commit('setModelDetail', { data: res, loading: false });
  } catch (e) {
    commit('setModelDetail', { data: null, loading: false });
  }
};

// 查询颜色参数(这里单独用详情接口,是为了更新颜色信息时,只更新颜色模块的数据,不会导致整个详情页面刷新)
export const queryModelColor: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setModelColor', { data: [], loading: true });
    // const res: { colorInfo: string } = await $http.get(`/model/type/item/detail/${payload}`);
    const res: { colorInfo: string } = await $http.get(`/v1/asset/item/${payload}/detail`);
    const data = JSON.parse(res.colorInfo || '{}').colors || [];
    commit('setModelColor', { data, loading: false });
  } catch (e) {
    commit('setModelColor', { data: [], loading: false });
  }
};

// 通过路径查询材料实例(暂时没用到)
export const queryInstances: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setInstances', { data: [], loading: true });
    const res: IInstanceRawData = await $http.post('/model/type/item/check', payload);
    const defaults = { fullpath: payload.fullpath, valid: res.valid, bindId: res.id, url: '', type: '', size: 0 };
    const data = [{ ...defaults, ...res.fileInfo }];
    commit('setInstances', { data, loading: false });
  } catch (e) {
    commit('setInstances', { data: [], loading: false });
  }
};

// 添加物品
export const addModel: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    // const res: { id: string } = await $http.post('/model/type/item/add', payload);
    const res: { id: string } = await $http.post('/v1/asset/item/add', payload);
    commit('setLoading', false);
    store.commit('common/setToast', { visible: true, text: '添加成功, 2秒后跳转到编辑页面' });
    setTimeout(() => router.push({ name: 'materials-model-edit', params: { id: res.id } }), 2000);
    return true;
  } catch (e) {
    commit('setLoading', false);
    return false;
  }
};

// 编辑物品
export const editModel: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    // await $http.post('/model/type/item/modify', payload);
    await $http.post('/v1/asset/item/modify', payload);
    commit('setLoading', false);
    store.commit('common/setToast', { visible: true, text: '编辑成功' });
    return true;
  } catch (e) {
    commit('setLoading', false);
    return false;
  }
};

// 批量删除物品
export const batchDeleteModel: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    // await $http.post('/model/type/item/batch/delete', payload);
    await $http.post('/v1/asset/item/delete', payload);
    commit('setConfirm', { visible: false, loading: false });
  } catch (e) {
    commit('setConfirm', { visible: false, loading: false });
  }
};

// 批量上下架
export const batchShelfModel: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    // await $http.post('/model/type/item/batch/shelf', payload);
    await $http.post('/v1/asset/item/shelf', payload);
    commit('setConfirm', { visible: false, loading: false });
  } catch (e) {
    commit('setConfirm', { visible: false, loading: false });
  }
};

// 批量刷新物品索引
export const batchRefreshIndex: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    // await $http.post('/model/type/item/batch/refresh', payload);
    await $http.post('/v1/asset/item/refresh', payload);
    store.commit('common/setToast', { visible: true, text: '索引刷新成功' });
  } finally {
    commit('setConfirm', { visible: false });
  }
};

// 批量刷新颜色信息
export const batchRefreshColor: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    // await $http.post('/model/type/item/refresh/color', payload);
    await $http.post('/v1/asset/item/refreshcolor', payload);
    store.commit('common/setToast', { visible: true, text: '颜色刷新成功' });
  } finally {
    commit('setConfirm', { visible: false });
  }
};

// 查询 AI 维度树
export const queryAiDimensionTree: IActionFn<IModuleState> = async () => {
  return await $http.get('/v1/asset/item/ai/dimension/tree');
};

// 查询物品 AI 维度标签
export const queryModelAiTags: IActionFn<IModuleState> = async ({ commit }, itemId) => {
  return await $http.get(`/v1/asset/item/${itemId}/ai-tags`);
};

// AI 标注物品维度
export const analyzeModelAiTags: IActionFn<IModuleState> = async ({ commit }, payload) => {
  const overwrite = payload.overwrite ? 'true' : 'false';
  const body = payload.dimensionCodes && payload.dimensionCodes.length
    ? { dimensionCodes: payload.dimensionCodes }
    : {};
  const res = await $http.post(`/v1/asset/item/${payload.itemId}/ai-tags/analyze?overwrite=${overwrite}`, body);
  store.commit('common/setToast', { visible: true, text: 'AI标注已完成' });
  return res;
};

// 保存物品 AI 维度标签
export const saveModelAiTags: IActionFn<IModuleState> = async ({ commit }, payload) => {
  const res = await $http.post(`/v1/asset/item/${payload.itemId}/ai-tags/save`, { tags: payload.tags });
  store.commit('common/setToast', { visible: true, text: 'AI维度保存成功' });
  return res;
};

// 批量 AI 标注
export const batchAnalyzeModelAiTags: IActionFn<IModuleState> = async ({ commit }, payload) => {
  const res = await $http.post('/v1/asset/item/ai-tags/batch/analyze', payload);
  store.commit('common/setToast', { visible: true, text: '批量AI标注任务已创建' });
  return res;
};

// 恢复最近一次批量任务
export const queryLatestModelAiBatch: IActionFn<IModuleState> = async () => {
  return await $http.get('/v1/asset/item/ai-tags/batch/latest');
};

export const retryModelAiBatch: IActionFn<IModuleState> = async (_, payload) => {
  return await $http.post(`/v1/asset/item/ai-tags/batch/${payload.batchNo}/retry?textOnly=${payload.textOnly}`, {});
};

// 查询批量 AI 标注任务
export const queryModelAiBatch: IActionFn<IModuleState> = async ({ commit }, batchNo) => {
  return await $http.get(`/v1/asset/item/ai-tags/batch/${batchNo}`);
};

// 同步物品 AI 标签到知识库
export const syncModelAiKnowledge: IActionFn<IModuleState> = async ({ commit }, itemId) => {
  const res: IAiKnowledgeSync = await $http.post(`/v1/asset/item/${itemId}/ai-tags/sync-knowledge`, {});
  const failed = res && res.syncStatus === 'failed';
  store.commit('common/setToast', {
    visible: true,
    text: failed ? `知识库同步失败：${res.errorMessage || '请查看同步记录'}` : '知识库同步已提交',
  });
  return res;
};

// 更新物品缩略图
export const updateModelThumb: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setModelThumb', { ...state.thumb, loading: true });
    // const res = await $http.post('/model/type/item/modify/img', payload);
    const res = await $http.post('/v1/asset/item/modifyimg', payload);
    commit('setModelThumb', { data: res, loading: false });
  } catch (e) {
    commit('setModelThumb', { data: null, loading: false });
  }
};

// 更新物品颜色信息
export const updateModelColor: IActionFn<IModuleState> = async ({ commit }, payload) => {
  // await $http.post('/model/type/item/modify/color', payload);
  await $http.post('/v1/asset/item/modifycolor', payload);
  store.commit('common/setToast', { visible: true, text: '颜色保存成功' });
};

// 新增价格
export const addModelPrice: IActionFn<IModuleState> = async ({ rootState }, payload) => {
  const commitType = 'materials/common/setDialogPrice'; // 对应的文件路径为: /src/store/materials/common/mutations
  const commitState = rootState.materials.common.dialogPrice;

  try {
    store.commit(commitType, { ...commitState, loading: true });
    // await $http.post('/item/business/model/add', payload);
    await $http.post('/v1/asset/item/addprice', payload);
  } finally {
    store.commit(commitType, { visible: false });
  }
};

// 编辑价格
export const editModelPrice: IActionFn<IModuleState> = async ({ rootState }, payload) => {
  const commitType = 'materials/common/setDialogPrice'; // 对应的文件路径为: /src/store/materials/common/mutations
  const commitState = rootState.materials.common.dialogPrice;

  try {
    store.commit(commitType, { ...commitState, loading: true });
    // await $http.post('/item/business/model/modify', payload);
    await $http.post('/v1/asset/item/modifyprice', payload);
  } finally {
    store.commit(commitType, { visible: false });
  }
};

// 导出价格
export const exportModelPrice: IActionFn<IModuleState> = async ({ rootState }, payload) => {
  const commitType = 'materials/common/setDialogExport'; // 对应的文件路径为: /src/store/materials/common/mutations
  const commitState = rootState.materials.common.dialogExport;

  try {
    store.commit(commitType, { ...commitState, loading: true });
    // const res: { blob: Blob; filename: string } = await $file.post('/model/type/item/export', payload);
    const res: { blob: Blob; filename: string } = await $file.post('/v1/asset/item/exportprice', payload);
    downloadFile(res.blob, '物品价格列表');
  } finally {
    store.commit(commitType, { visible: false });
  }
};

// 导入价格
export const importModelPrice: IActionFn<IModuleState> = async ({ rootState }, payload) => {
  const commitType = 'materials/common/setDialogImport'; // 对应的文件路径为: /src/store/materials/common/mutations
  const commitState = rootState.materials.common.dialogImport;

  try {
    const { type, file } = payload;
    const formData = new FormData();
    formData.append('type', type);
    formData.append('file', file);
    formData.append('fileName', file.name);
    store.commit(commitType, { ...commitState, loading: true });
    // await $http.post('/item/import', payload);
    await $http.post('/v1/asset/item/importprice', formData);
    store.commit('common/setToast', { visible: true, text: '价格导入成功' });
  } finally {
    store.commit(commitType, { visible: false });
  }
};

// 导出关键字
export const exportModelKeyword: IActionFn<IModuleState> = async ({ rootState }, payload) => {
  const commitType = 'materials/common/setDialogExport'; // 对应的文件路径为: /src/store/materials/common/mutations
  const commitState = rootState.materials.common.dialogExport;

  try {
    store.commit(commitType, { ...commitState, loading: true });
    // const res: { blob: Blob; filename: string } = await $file.post('/keyword/model/export', payload);
    const res: { blob: Blob; filename: string } = await $file.post('/v1/asset/item/exportkeywords', payload);
    downloadFile(res.blob, '物品关键字列表');
  } finally {
    store.commit(commitType, { visible: false });
  }
};

// 导入关键字
export const importModelKeyword: IActionFn<IModuleState> = async ({ rootState }, payload) => {
  const commitType = 'materials/common/setDialogImport'; // 对应的文件路径为: /src/store/materials/common/mutations
  const commitState = rootState.materials.common.dialogImport;

  try {
    const { file } = payload;
    const formData = new FormData();
    formData.append('file', file);
    formData.append('fileName', file.name);
    store.commit(commitType, { ...commitState, loading: true });
    // await $http.post('/keyword/model/input', payload);
    await $http.post('/v1/asset/item/inputkeywords', formData);
    store.commit('common/setToast', { visible: true, text: '关键字导入成功' });
  } finally {
    store.commit(commitType, { visible: false });
  }
};

// 导出供应商
export const exportModelSupplier: IActionFn<IModuleState> = async ({ rootState }, payload) => {
  const commitType = 'materials/common/setDialogExport'; // 对应的文件路径为: /src/store/materials/common/mutations
  const commitState = rootState.materials.common.dialogExport;

  try {
    store.commit(commitType, { ...commitState, loading: true });
    // const res: { blob: Blob; filename: string } = await $file.post('/model/type/item/supplier/export', payload);
    const res: { blob: Blob; filename: string } = await $file.post('/v1/asset/item/exportsuppliercode', payload);
    downloadFile(res.blob, '物品供应商列表');
  } finally {
    store.commit(commitType, { visible: false });
  }
};

// 导入供应商
export const importModelSupplier: IActionFn<IModuleState> = async ({ rootState }, payload) => {
  const commitType = 'materials/common/setDialogImport'; // 对应的文件路径为: /src/store/materials/common/mutations
  const commitState = rootState.materials.common.dialogImport;

  try {
    const { file } = payload;
    const formData = new FormData();
    formData.append('file', file);
    formData.append('fileName', file.name);
    store.commit(commitType, { ...commitState, loading: true });
    // await $http.post('/model/type/item/supplier/code/import', payload);
    await $http.post('/v1/asset/item/importsuppliercode', formData);
    store.commit('common/setToast', { visible: true, text: '供应商导入成功' });
  } finally {
    store.commit(commitType, { visible: false });
  }
};

// 查询物品已保存的过滤配置
export const queryModelFilter: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setModelFilters', { data: [], loading: true });
    // const res = await $http.post('/model/type/item/filter/list', payload);
    const res = await $http.post('/v1/asset/item/filter/list', payload);
    commit('setModelFilters', { data: res, loading: false });
  } catch (e) {
    commit('setModelFilters', { data: [], loading: false });
  }
};

// 删除过滤配置
export const deleteModelFilter: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    // await $http.post('/model/type/item/filter/delete', payload);
    await $http.post('/v1/asset/item/filter/delete', payload);
    return true;
  } catch (e) {
    return false;
  }
};

// 保存过滤配置
export const saveModelFilter: IActionFn<IModuleState> = async ({ commit }, payload) => {
  // await $http.post('/model/type/item/filter/batch/modify', payload);
  await $http.post('/v1/asset/item/filter/modify', payload);
  store.commit('common/setToast', { visible: true, text: '保存成功' });
};
